import { Box, Flex, HStack } from '@chakra-ui/react'
import Details from './Details'
import MainContent from './MainContent'
import NavbarAlt from '../../components/NavbarAlt'
import colors from '../../config/theme/colors'
import useInitial from './useInitial'
import Initial from '../../components/Initial'

export default function ConfirmOrder() {
    const {
        pageState,
        order_id,
        account_id,
        client_id,
        delivery_id,
        table_id,
        action
    } = useInitial()

    let path: string | undefined
    if (order_id && account_id) {
        if (action === 'split') {
            path = `/orders/${order_id}/confirm/split?delivery_id=${delivery_id}&client_id=${client_id}`
        } else {
            path = `/orders/${order_id}/confirm/split`
        }
    } else if (order_id && client_id && delivery_id && !table_id) {
        path = `/deliveries/${delivery_id}/customers`
    } else if (order_id && !account_id) {
        path = `/quick_sale_by/tables?table_id=${table_id}`
    } else {
        path = `/quick_sale`
    }

    return (
        <Box minH="100vh" bg="base-4">
            <NavbarAlt title="Confirmar pedido" path={path} />
            <Initial pageState={pageState} h="calc(100vh - 60px)">
                <HStack
                    w="full"
                    display="flex"
                    align="stretch"
                    flexDirection={{ base: 'column', md: 'row' }}
                >
                    <Box
                        w="full"
                        px={{
                            xl: '16',
                            base: '1'
                        }}
                        py={{
                            xl: '10',
                            base: '6'
                        }}
                        bg="white"
                        minH={{ base: 'fit-content', md: 'calc(100vh - 60px)' }}
                    >
                        <MainContent />
                    </Box>
                    <Flex
                        minW={{
                            xl: '550px',
                            lg: '400px'
                        }}
                        minH={{ base: 'fit-content', md: 'calc(100vh - 60px)' }}
                        color={colors['alo-gray']}
                        p={{
                            base: '4',
                            md: '6'
                        }}
                        flexDirection="column"
                        marginLeft={0}
                    >
                        <Details />
                    </Flex>
                </HStack>
            </Initial>
        </Box>
    )
}
